angular.module('picmonicng').directive('learnAudioSpeed', [
  'LearnService',
  'UserService',
  function (LearnService, UserService) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/learn-audio-speed.html',
      link: function (scope, element, attrs) {
        scope.UserService = UserService;

        element.removeClass('dropdown');

        // Handle keyboard events
        element.on('focusout', function (e) {
          if (angular.element(e.target).hasClass('dropdown-toggle')) {
            element.find('li:first').focus();
          } else if (angular.element(e.target).hasClass('last')) {
            element.removeClass('open');
          }
        });
      },
    };
  },
]);
